import {
  faAt,
  faKey,
  faRightToBracket,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Header from "../../utils/components/Header/Header";
import Endpoints from "../../utils/repository/Endpoints";
import { GetRequest } from "../../utils/repository/RequestMaker";
import FormInput from "../../utils/components/FormInput/FormInput";
import { addUser } from "./loginSlice";
import Swal from "sweetalert2";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });
  const dispatch = useDispatch();

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      Swal.fire({
        icon: "warning",
        title: "Fehler",
        text: "E-Mail und Passwort sind erforderlich",
        allowOutsideClick: false,
      });
      return;
    }

    setIsSubmitting(true);
    const payload = JSON.stringify({ email, password });

    try {
      const loginResponse = await fetch(Endpoints.api + Endpoints.login, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: payload,
      });

      const loginData = await loginResponse.json();

      if (!loginResponse.ok) {
        throw new Error(
          loginData.message || "Ein unbekannter Fehler ist aufgetreten."
        );
      }

      if (!loginData.data || !loginData.data.token) {
        throw new Error(
          "Hier stimmt etwas nicht! Bitte versuchen Sie es nach einiger Zeit erneut!"
        );
      }

      console.log(loginData);
      localStorage.setItem("token", loginData.data.token);
      const company_id = loginData.data.user.company_id;
      console.log(company_id);
      localStorage.setItem("company_id", JSON.stringify(company_id));

      const res8 = await GetRequest(Endpoints.companies);
      for (const company of res8.data) {
        if (company.id === company_id) {
          localStorage.setItem(
            "display_only_private_data",
            company.private_data
          );
        }
      }
      console.log(res8.data);

      dispatch(addUser(loginData.data.user));

      if (loginData.data.user.role === "admin") {
        Swal.fire({
          icon: "success",
          title: "Admin-Login erfolgreich",
          allowOutsideClick: false,
          timer: 2000,
          timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading();
          },
          willClose: () => {
            navigate("/admin/dashboard");
          },
        });
        setIsSubmitting(false);
        return;
      }

      await fetchAdditionalUserData();
      setIsSubmitting(false);

      Swal.fire({
        icon: "success",
        title: "Login erfolgreich",
        allowOutsideClick: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
        willClose: () => {
          navigate("/");
        },
      });
    } catch (error) {
      setIsSubmitting(false);
      Swal.fire({
        icon: "error",
        title: "Fehler",
        text: error.message,
        allowOutsideClick: false,
      });
    }
  };

  async function fetchAdditionalUserData() {
    try {
      const res1 = await GetRequest(Endpoints.inspectionType);
      localStorage.setItem("inspectionType", JSON.stringify(res1.data));

      const res2 = await GetRequest(Endpoints.incident_questions);
      localStorage.setItem("incident_questions", JSON.stringify(res2.data));

      const res3 = await GetRequest(Endpoints.risk_categories);
      localStorage.setItem("risk_categories", JSON.stringify(res3.data));

      const res4 = await GetRequest(Endpoints.risk_sub_categories);
      localStorage.setItem("risk_sub_categories", JSON.stringify(res4.data));

      const res5 = await GetRequest(Endpoints.risk_sub_categories_type);
      localStorage.setItem(
        "risk_sub_categories_type",
        JSON.stringify(res5.data)
      );
      const res6 = await GetRequest(Endpoints.risk_solutions);
      localStorage.setItem("risk_solutions", JSON.stringify(res6.data));

      const res7 = await GetRequest(Endpoints.company_type);
      localStorage.setItem("company_type", JSON.stringify(res7.data));
    } catch (error) {
      console.error("Error fetching additional user data:", error);
    }
  }

  useEffect(() => {
    //localStorage.clear();
  }, []);

  return (
    <>
      <Header />
      <div
        id={"event"}
        style={{
          marginTop: 10,
          padding: 10,
          overflow: "hidden",
          height: "auto",
        }}
      >
        <div
          className={isPortrait ? "container-fluid" : "container"}
          style={{ maxWidth: 750 }}
        >
          <div className="display-6 mb-3">Willkommen!</div>
          <form onSubmit={onSubmit}>
            {" "}
            <FormInput
              type="email"
              id="user_email"
              placeholder="name@example.com"
              label="Email address"
              hint=""
              icon={faAt}
              value={email}
              setValue={setEmail}
              required
            />
            <FormInput
              type="password"
              id="user_password"
              placeholder="xxxxx"
              label="Passwort"
              hint=""
              icon={faKey}
              value={password}
              setValue={setPassword}
              required
            />
            <div>
              <Link
                to="/forgot-password"
                style={{ color: "#332885", textDecoration: "none" }}
              >
                Passwort vergessen?
              </Link>
            </div>
            <div
              className="d-flex justify-content-end"
              style={{ marginTop: 20 }}
            >
              {isSubmitting ? (
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    height: 50,
                    width: "100%",
                    transition: "0.3s",
                    backgroundColor: "#332885",
                    color: "white",
                    border: "1px solid #332885",
                    borderRadius: 5,
                  }}
                  id="login_submitting"
                >
                  <div className="spinner-border text-light" role="status">
                    <span className="visually-hidden">Wird geladen...</span>
                  </div>
                </div>
              ) : (
                <button
                  type="submit"
                  style={{
                    height: 50,
                    width: "100%",
                    transition: "0.3s",
                    backgroundColor: "#332885",
                    color: "white",
                    border: "1px solid #332885",
                    borderRadius: 5,
                  }}
                >
                  Login <FontAwesomeIcon icon={faRightToBracket} />
                </button>
              )}
            </div>
          </form>
          <div className="mt-4 text-center">
            <span>Sie haben noch kein Konto? </span>
            <Link
              to="/register"
              style={{ color: "#332885", textDecoration: "none" }}
            >
              Hier registrieren
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
